var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIdentity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1410_13559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 3.99996C8.73268 3.99996 9.33268 4.59996 9.33268 5.33329C9.33268 6.06663 8.73268 6.66663 7.99935 6.66663C7.26602 6.66663 6.66602 6.06663 6.66602 5.33329C6.66602 4.59996 7.26602 3.99996 7.99935 3.99996ZM7.99935 9.99996C9.79935 9.99996 11.866 10.86 11.9993 11.3333V12H3.99935V11.34C4.13268 10.86 6.19935 9.99996 7.99935 9.99996ZM7.99935 2.66663C6.52602 2.66663 5.33268 3.85996 5.33268 5.33329C5.33268 6.80663 6.52602 7.99996 7.99935 7.99996C9.47268 7.99996 10.666 6.80663 10.666 5.33329C10.666 3.85996 9.47268 2.66663 7.99935 2.66663ZM7.99935 8.66663C6.21935 8.66663 2.66602 9.55996 2.66602 11.3333V13.3333H13.3327V11.3333C13.3327 9.55996 9.77935 8.66663 7.99935 8.66663Z",
    fill: "#312E40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1410_13559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIdentity);
export default __webpack_public_path__ + "static/media/icon-identity.1387d68dcc5eacc7ef4a603f21e86574.svg";
export { ForwardRef as ReactComponent };